import { render, staticRenderFns } from "./MspEditImpegno.vue?vue&type=template&id=3a38317e"
import script from "./MspEditImpegno.vue?vue&type=script&lang=js"
export * from "./MspEditImpegno.vue?vue&type=script&lang=js"
import style0 from "./MspEditImpegno.vue?vue&type=style&index=0&id=3a38317e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports